export default __webpack_public_path__ + "static/media/ic-fx.6f01d12e.svg";